<template>
  <div class="tickets-table-container">
    <!-- Filters -->
    <el-row :gutter="20" class="mb-4">
      <el-col :span="12" class="text-left">
        <el-input v-model="searchedCategory" size="small" placeholder="Search Category" suffix-icon="el-icon-search" style="max-width: 200px;"></el-input>
      </el-col>
      <el-col :span="12" class="text-right">
        <el-button icon="el-icon-download" size="small" plain @click="downloadCategoryReport">CSV</el-button>
      </el-col>
    </el-row>
    <!-- Table -->
    <el-table :data="paginatedTableData" height="400">
      <el-table-column prop="location" label="Category" align="center">
        <template slot="header" slot-scope="scope">
          Category
          <el-popover placement="right" trigger="click">
            <el-input
              v-model="searchedFilterCategory"
              size="mini"
              placeholder="Search Category"
            ></el-input>
            <div
              style="max-height: 250px; overflow: auto; margin-top: 10px"
            >
              <el-checkbox-group v-model="selectedFilterCategory">
                <el-checkbox
                  v-for="(categoryItem, index) in uniqueCategories.filter(
                    (el) =>
                      !searchedFilterCategory ||
                      el.toLowerCase().includes(searchedFilterCategory.toLowerCase())
                  )"
                  :key="index"
                  class="mb-2 checkbox-lable"
                  :label="categoryItem"
                  style="display: block"
                ></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="flex justify-between mt-4">
              <span
                class="text-xs cursor-pointer primary-theme-color"
                @click="selectedFilterCategory = [...uniqueCategories]"
                >Select all</span
              >
              <span
                class="text-xs cursor-pointer"
                @click="selectedFilterCategory = [];"
                >Reset</span
              >
            </div>
            <span slot="reference">
              <img
                v-if="selectedFilterCategory.length"
                src="../../../../assets/images/filter.png"
                width="9"
                class="cursor-pointer"
              />
              <img
                v-else
                src="../../../../assets/images/filterBlack.png"
                width="9"
                class="cursor-pointer"
              />
            </span>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <b class="capitalize">{{ scope.row.category }}</b>
        </template>
      </el-table-column>
      <el-table-column prop="total_tickets" label="Total Tickets" align="center">
        <template slot="header" slot-scope="scope">
          Total Tickets
          <i v-if="totalTicketsSortby == 'desc'" class="el-icon-caret-top icon-black cursor-pointer" @click="sortFilter('totalTicketsSortby', 'asc')"></i>
          <i v-else-if="totalTicketsSortby == 'asc' || totalTicketsSortby == ''" class="el-icon-caret-bottom icon-black cursor-pointer" @click="sortFilter('totalTicketsSortby', 'desc')"></i>
        </template>
        <template slot-scope="scope">
          {{ scope.row.total_tickets }}
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="open_tickets" label="Open" align="center">
        <template slot="header" slot-scope="scope">
          Open
          <i v-if="openTicketsSortby == 'desc'" class="el-icon-caret-top icon-black cursor-pointer" @click="sortFilter('openTicketsSortby', 'asc')"></i>
          <i v-else-if="openTicketsSortby == 'asc' || openTicketsSortby == ''" class="el-icon-caret-bottom icon-black cursor-pointer" @click="sortFilter('openTicketsSortby', 'desc')"></i>
        </template>
        <template slot-scope="scope">
          {{ scope.row.open_tickets }}
        </template>
      </el-table-column>
      <el-table-column prop="closed_tickets" label="Open" align="center">
        <template slot="header" slot-scope="scope">
          Closed
          <i v-if="closedTicketsSortby == 'desc'" class="el-icon-caret-top icon-black cursor-pointer" @click="sortFilter('closedTicketsSortby', 'asc')"></i>
          <i v-else-if="closedTicketsSortby == 'asc' || closedTicketsSortby == ''" class="el-icon-caret-bottom icon-black cursor-pointer" @click="sortFilter('closedTicketsSortby', 'desc')"></i>
        </template>
        <template slot-scope="scope">
          {{ scope.row.closed_tickets }}
        </template>
      </el-table-column>
      <el-table-column prop="within_sla" label="Within SLA" align="center">
        <template slot="header" slot-scope="scope">
          Within SLA
          <i v-if="withSlaSortby == 'desc'" class="el-icon-caret-top icon-black cursor-pointer" @click="sortFilter('withSlaSortby', 'asc')"></i>
          <i v-else-if="withSlaSortby == 'asc' || withSlaSortby == ''" class="el-icon-caret-bottom icon-black cursor-pointer" @click="sortFilter('withSlaSortby', 'desc')"></i>
        </template>
        <template slot-scope="scope">
          {{ scope.row.within_sla }}
        </template>
      </el-table-column>
      <el-table-column prop="sla_percentage" label="SLA %" align="center">
        <template slot="header" slot-scope="scope">
          SLA %
          <i v-if="slaPercentageSortby == 'desc'" class="el-icon-caret-top icon-black cursor-pointer" @click="sortFilter('slaPercentageSortby', 'asc')"></i>
          <i v-else-if="slaPercentageSortby == 'asc' || slaPercentageSortby == ''" class="el-icon-caret-bottom icon-black cursor-pointer" @click="sortFilter('slaPercentageSortby', 'desc')"></i>
        </template>
        <template slot-scope="scope">
          {{ scope.row.sla_percentage }}%
        </template>
      </el-table-column>
      <el-table-column prop="sla_violation" label="SLA Violation" align="center">
        <template slot="header" slot-scope="scope">
          SLA Violation
          <i v-if="violationSortby == 'desc'" class="el-icon-caret-top icon-black cursor-pointer" @click="sortFilter('violationSortby', 'asc')"></i>
          <i v-else-if="violationSortby == 'asc' || violationSortby == ''" class="el-icon-caret-bottom icon-black cursor-pointer" @click="sortFilter('violationSortby', 'desc')"></i>
        </template>
        <template slot-scope="scope">
          {{ scope.row.sla_violation }}
        </template>
      </el-table-column>
      <el-table-column prop="violation_percentage" label="Violation %" align="center">
        <template slot="header" slot-scope="scope">
          Violation %
          <i v-if="violationPercentageSortby == 'desc'" class="el-icon-caret-top icon-black cursor-pointer" @click="sortFilter('violationPercentageSortby', 'asc')"></i>
          <i v-else-if="violationPercentageSortby == 'asc' || violationPercentageSortby == ''" class="el-icon-caret-bottom icon-black cursor-pointer" @click="sortFilter('violationPercentageSortby', 'desc')"></i>
        </template>
        <template slot-scope="scope">
          {{ scope.row.violation_percentage }}%
        </template>
      </el-table-column>
      <el-table-column prop="avg_resolution_time" label="Average Resolution Time" align="center" width="300">
        <template slot="header" slot-scope="scope">
          Average Resolution Time
          <i v-if="avgResponseTimeSortby == 'desc'" class="el-icon-caret-top icon-black cursor-pointer" @click="sortFilter('avgResponseTimeSortby', 'asc')"></i>
          <i v-else-if="avgResponseTimeSortby == 'asc' || avgResponseTimeSortby == ''" class="el-icon-caret-bottom icon-black cursor-pointer" @click="sortFilter('avgResponseTimeSortby', 'desc')"></i>
        </template>
        <template slot-scope="scope">
          <span class="capitalize">{{ scope.row.avg_resolution_time }} Hrs</span>
        </template>
      </el-table-column>
      -->
      <!-- <el-table-column align="center">
        <template slot-scope="scope">
          <el-button type="text" class="tickets-table-action-btn">view details</el-button>
        </template>
      </el-table-column> -->
      <el-table-column prop="category_percentage" label="Category %" align="center">
        <template slot="header" slot-scope="scope">
          Category %
          <i v-if="categoryPercentageSortby == 'desc'" class="el-icon-caret-top icon-black cursor-pointer" @click="sortFilter('categoryPercentageSortby', 'asc')"></i>
          <i v-else-if="categoryPercentageSortby == 'asc' || categoryPercentageSortby == ''" class="el-icon-caret-bottom icon-black cursor-pointer" @click="sortFilter('categoryPercentageSortby', 'desc')"></i>
        </template>
        <template slot-scope="scope">
          <span class="capitalize">{{ scope.row.category_percentage }}%</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <el-row :gutter="20" class="mt-8 mb-4">
      <el-col :span="8" class="text-left">
        <div><b>Showing</b> {{ startIndex }} to {{ endIndex }} of {{ totalTicketData }} results</div>
      </el-col>
      <el-col :span="8" class="text-center">
        <el-select v-model="perPage" name="per_page" placeholder="select per page" style="width: 90px !important;" size="mini">
          <el-option label="10" :value="10"></el-option>
          <el-option label="25" :value="25"></el-option>
          <el-option label="50" :value="50"></el-option>
          <el-option label="100" :value="100"></el-option>
        </el-select>
        &nbsp;&nbsp;<b>per page</b>
      </el-col>
      <el-col :span="8" class="text-right">
        <el-pagination background layout="prev, pager, next" :total="totalTicketData"
          :page-size="perPage" :current-page.sync="currentPage"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ticketDashboardMixins from '../../../../../mixins/ticketDashboardMixins';
import exportFromJSON from 'export-from-json';
export default {
  name: "TicketsCategoryTable",
  mixins: [ticketDashboardMixins],
  data() {
    return {
      searchedCategory: '',
      searchedFilterCategory: '',
      selectedFilterCategory: [],
      currentPage: 1,
      perPage: 10,
      totalTicketsSortby: '',
      openTicketsSortby: '',
      closedTicketsSortby: '',
      withSlaSortby: '',
      slaPercentageSortby: '',
      violationSortby: '',
      violationPercentageSortby: '',
      avgResponseTimeSortby: '',
      categoryPercentageSortby: '',
    };
  },
  computed: {
    ticketCategoryTableData() {
      let result = this.ticket_data.map(el => ({
        id: el.basics,
        category: el.name ? el.name.trim() : el.name,
        total_tickets: el.total,
        open_tickets: el.open,
        closed_tickets: el.closed,
        within_sla: el.within_sla,
        sla_percentage: el.within_sla_percentage,
        sla_violation: el.violation,
        violation_percentage: el.violation_percentage,
        avg_resolution_time: el.average_rt,
        category_percentage: el.category_percentage
      }));
      // Category search 
      if(this.searchedCategory) {
        result = result.filter(el => el.category.toLowerCase().includes(this.searchedCategory.toLowerCase()));
      }
      // Category filter
      if(this.selectedFilterCategory && this.selectedFilterCategory.length) {
        result = result.filter(el => this.selectedFilterCategory.includes(el.category));
      }
      // tickets sort filter 
      if(this.totalTicketsSortby) {
        if(this.totalTicketsSortby == 'asc') {
          result.sort((a, b) => a.total_tickets - b.total_tickets);
        } else if(this.totalTicketsSortby == 'desc') {
          result.sort((a, b) => b.total_tickets - a.total_tickets);
        }
      } else if(this.withSlaSortby) {
        if(this.withSlaSortby == 'asc') {
          result.sort((a, b) => a.within_sla - b.within_sla);
        } else if(this.withSlaSortby == 'desc') {
          result.sort((a, b) => b.within_sla - a.within_sla);
        }
      } else if(this.openTicketsSortby) {
        if(this.openTicketsSortby == 'asc') {
          result.sort((a, b) => a.open_tickets - b.open_tickets);
        } else if(this.openTicketsSortby == 'desc') {
          result.sort((a, b) => b.open_tickets - a.open_tickets);
        }
      } else if(this.closedTicketsSortby) {
        if(this.closedTicketsSortby == 'asc') {
          result.sort((a, b) => a.closed_tickets - b.closed_tickets);
        } else if(this.closedTicketsSortby == 'desc') {
          result.sort((a, b) => b.closed_tickets - a.closed_tickets);
        }
      } else if(this.categoryPercentageSortby) {
        if(this.categoryPercentageSortby == 'asc') {
          result.sort((a, b) => a.category_percentage - b.category_percentage);
        } else if(this.categoryPercentageSortby == 'desc') {
          result.sort((a, b) => b.category_percentage - a.category_percentage);
        }
      } else if(this.slaPercentageSortby) {
        if(this.slaPercentageSortby == 'asc') {
          result.sort((a, b) => a.sla_percentage - b.sla_percentage);
        } else if(this.slaPercentageSortby == 'desc') {
          result.sort((a, b) => b.sla_percentage - a.sla_percentage);
        }
      } else if(this.violationSortby) {
        if(this.violationSortby == 'asc') {
          result.sort((a, b) => a.sla_violation - b.sla_violation);
        } else if(this.violationSortby == 'desc') {
          result.sort((a, b) => b.sla_violation - a.sla_violation);
        }
      } else if(this.violationPercentageSortby) {
        if(this.violationPercentageSortby == 'asc') {
          result.sort((a, b) => a.violation_percentage - b.violation_percentage);
        } else if(this.violationPercentageSortby == 'desc') {
          result.sort((a, b) => b.violation_percentage - a.violation_percentage);
        }
      } else if(this.avgResponseTimeSortby) {
        if(this.avgResponseTimeSortby == 'asc') {
          result.sort((a, b) => a.avg_resolution_time - b.avg_resolution_time);
        } else if(this.avgResponseTimeSortby == 'desc') {
          result.sort((a, b) => b.avg_resolution_time - a.avg_resolution_time);
        }
      }
      return result;
    },
    paginatedTableData() {
      let filterData = this.ticketCategoryTableData.filter((el, index) => index >= this.startIndex - 1 && index <= this.endIndex);
      if(filterData.length) {
        let summaryItem = {
          id: '',
          category: 'Total',
          total_tickets: this.tickets_dashboard_summary.total,
          open_tickets: this.tickets_dashboard_summary.open,
          closed_tickets: this.tickets_dashboard_summary.closed,
          within_sla: this.tickets_dashboard_summary.within_sla,
          sla_percentage: this.tickets_dashboard_summary.within_sla_percentage,
          sla_violation: this.tickets_dashboard_summary.violation,
          violation_percentage: this.tickets_dashboard_summary.violation_percentage,
          avg_resolution_time: this.tickets_dashboard_summary.average_rt,
          category_percentage: this.tickets_dashboard_summary.category_percentage
        };
        filterData = [summaryItem, ...filterData];
      }
      return filterData;
    },
    uniqueCategories() {
      let result = [...new Set(this.ticket_data.filter(el => el.name).map(el => el.name.trim()))];
      return result;
    },
    totalTicketData() {
      return this.ticketCategoryTableData.length;
    },
    startIndex() {
      let start = (this.currentPage * this.perPage) - (this.perPage - 1);
      return start;
    },
    endIndex() {
      let end = Math.min(this.startIndex + this.perPage - 1, this.totalTicketData);
      return end;
    }
  },
  methods: {
    downloadCategoryReport() {
      let data = this.ticket_data.map((el, index) => ({
        'Category': this.$options.filters.titleCase(el.name),
        'Total Tickets': el.total,
        // 'Open': el.open,
        // 'Closed': el.closed,
        // 'Within SLA': el.within_sla,
        // 'SLA %': el.within_sla_percentage + '%',
        // 'SLA Violation': el.violation,
        // 'Violation %': el.violation_percentage + '%',
        // 'Average Resolution Time': this.$options.filters.timeLabel(el.average_rt),
        'Category %': el.category_percentage + '%',
      }));
      let summary = {
        'Category': 'Total',
        'Total Tickets': this.tickets_dashboard_summary.total,
        // 'Open': this.tickets_dashboard_summary.open,
        // 'Closed': this.tickets_dashboard_summary.closed,
        // 'Within SLA': this.tickets_dashboard_summary.within_sla,
        // 'SLA %': this.tickets_dashboard_summary.within_sla_percentage + '%',
        // 'SLA Violation': this.tickets_dashboard_summary.violation,
        // 'Violation %': this.tickets_dashboard_summary.violation_percentage + '%',
        'Category %': this.tickets_dashboard_summary.category_percentage + '%',
      };
      data = [summary, ...data];
      const fileName = 'Ticket_Category_Report';
      const exportType = exportFromJSON.types.csv;
      exportFromJSON({ data, fileName, exportType });
    },
    resetAllSorts() {
      this.totalTicketsSortby = '';
      this.openTicketsSortby = '';
      this.closedTicketsSortby = '';
      this.withSlaSortby = '';
      this.slaPercentageSortby = '';
      this.violationSortby = '';
      this.violationPercentageSortby = '';
      this.avgResponseTimeSortby = '';
      this.categoryPercentageSortby = '';
    },
    sortFilter(variable_name, value) {
      this.resetAllSorts();
      this.$data[variable_name] = value;
    }
  }
}
</script>